import React from 'react';
import './Become.css';
import Speaker from "../../img/Become/speaker.svg";
import Sponsor from "../../img/Become/sponsor.svg";
import Moderator from "../../img/Become/moderator.svg";

const Become = (props) => {
    const state = {
        Become_item: [ 
            {
                img: Speaker,
                title: 'Become a speaker',
                href: 'https://lnkd.in/dnUwGFXA',
            },
            // {
            //     img: Speaker,
            //     title: 'Become a Program Committee member',
            //     href: 'https://lnkd.in/djPBTqKj',
            // },
            {
                img: Moderator,
                title: 'Become a moderator',
                href: 'https://lnkd.in/dbRi_kVp',
            },
            {
                img: Sponsor,
                title: 'Become a sponsor',
                href: 'https://lnkd.in/dAnzjki3',
                sponsorship: 'https://drive.google.com/file/d/1LiqqpA6P34LPUAiC28EicGe6RF33PLAv/view?usp=sharing',
            },
      ],
    };

    const renderBecome_item = (item, i) => {
        return (
            <div className="become_item" key={`Numbers_item-${i}`}>
                <img src={item.img} alt="Become image" />
                <p className='become_title'>{item.title}</p>
                <a className='become_button' target='_blank' rel='noreffered' href={item.href}>Apply</a>
                {item.sponsorship && <a className='become_button become_button--sponsorship' target='_blank' rel='noreffered' href={item.sponsorship}>Prospectus</a>}
            </div>
        );
    };

    return (
        <div className="become">
            <div className="container">
                {state.Become_item.map((item, i) => renderBecome_item(item, i))}
            </div>
        </div>
    );
};

export default Become;